<div class="min-h-screen bg-background text-foreground transition-colors">
    <router-outlet></router-outlet>
</div>
